import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import Table from '../../../components/datatable/Table'
import NumberField from '../../../components/forms/NumberField'
import Select from '../../../components/forms/Select'
import { nbPerPageLabelShort } from '../../../referencial/constants/ReferencialConstants'
import DtoParametrageDataType from '../../../piezometry/dto/DtoParametrageDataType'
import { arrayOf } from '../../../utils/StoreUtils'
import { hasValue } from '../../../utils/NumberUtil'
import DtoMeasureStats from '../../../station/dto/piezometer/DtoMeasureStats'


const TabSelectThreshold = ({
    stations = [],
    dataTypes = [],
    thresholds = [],
    stationsSelected = [],
    onChangeStation = () => {},
    onChange = () => {},
    onDeleteStation = () => {},
    onDuplicateStation = () => {},
    disabled = true,
    actions= [],
    exportButtonOnHeader= false,
    stationType = 'hydrometry',
    stationsStats = {},
}) => {
    const getLine = (id, thresholdId, typeId, timeLinitMissingData, thresholdList, index, allLines) => ({
        station: (
            <Select
                options={stations}
                onChange={(_, value) => onChangeStation(value, index)}
                value={id}
                keyValue='id'
                clearFunction
                disabled={disabled}
                divInputStyle={ { width: 300 } }
                obligatory
            />
        ),
        dataType: (
            <Select
                options={((id && stationsStats[id]) ?? dataTypes)}
                onChange={v => onChange('typeId', v, index)}
                value={typeId}
                keyValue='id'
                keyLabel={'title'}
                disabled={disabled}
                divInputStyle={ { width: 300 } }
                obligatory
            />
        ),
        threshold: thresholdList.length ? (
            <Select
                options={thresholdList}
                value={thresholdId}
                onChange={v => onChange('thresholdId', v, index)}
                keyLabel={'title'}
                keyValue={'id'}
                nullLabel='&nbsp;'
                disabled={disabled}
                style={{ minWidth: '250px' }}
                divInputStyle={ { width: 300 } }
            />
        ) : (
            <div className='col s4 no-margin halign-wrapper'>
                <div className='col s12'>
                    <span >{i18n.noThresholds}</span>
                </div>
            </div>
        ),
        timeLinitMissingData: (
            <NumberField
                min={1}
                value={timeLinitMissingData}
                onChange={v => onChange('timeLinitMissingData', v, index)}
                disabled={disabled}
            />
        ),
        color: allLines.filter(s => s.id === id && s.thresholdId === thresholdId && s.typeId === typeId).length >= 2 ? 'red' : undefined,
    })

    const getList = () => stationsSelected.map(({ id, code, thresholdId, typeId, timeLinitMissingData }, i) => {
        const thresholdList = (() => {
            if (stationType === 'hydrometry') {
                return thresholds.filter(t => id?.toString() === t.stationId)
            }
            if (code) {
                return thresholds.filter(t => t.code && t.code.toLowerCase() === code.toLowerCase())
            }
            return []
        })()
        const thresholdListWithTypeId = hasValue(typeId) ? thresholdList.filter(t => t.dataType === typeId.toString()) : thresholdList
        return getLine(id, thresholdId, typeId, timeLinitMissingData, thresholdListWithTypeId, i, stationsSelected)
    })

    const exportData = stationsSelected.map(p => ({
        code: p.code,
        id: p.id,
        timeLinitMissingData: p.timeLinitMissingData,
        headers: ['code', 'id', 'timeLinitMissingData'],
    }))

    return (
        <div className='row no-margin card no-box-shadow transparent'>
            <div className='col s12 no-padding'>
                <div className='job-parameter-table'>
                    <Table
                        title={i18n.stations}
                        data={getList()}
                        type={{ headers: ['station', 'dataType', 'threshold', 'timeLinitMissingData'] }}
                        nbPerPageLabel={nbPerPageLabelShort}
                        deletable={!disabled}
                        onDelete={onDeleteStation}
                        duplicable={!disabled}
                        onDuplicate={onDuplicateStation}
                        sortable
                        condensed
                        paging
                        overflow='visible'
                        exportButtonOnHeader={ exportButtonOnHeader }
                        exportData={ exportData }
                        actions={ actions }
                        activeHeader
                        customWidthHeaders={{
                            station: '40%',
                            threshold: '30%',
                            timeLinitMissingData: '30%',
                        }}
                        customHeaders={{
                            station: <span>{i18n.station}<span className='primary-color-text'>{i18n.obligatoryField}</span></span>,
                            dataType: <span>{i18n.dataType}<span className='primary-color-text'>{i18n.obligatoryField}</span></span>,
                            timeLinitMissingData: <span>{i18n.timeLinitMissingData}</span>,
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

TabSelectThreshold.propTypes = {
    stationType: PropTypes.string,
    dataTypes: arrayOf(DtoParametrageDataType),
    stations: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        code: PropTypes.string,
        name: PropTypes.string,
    })),
    thresholds: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        code: PropTypes.string,
        title: PropTypes.string,
    })),
    stationsSelected: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        code: PropTypes.string,
        name: PropTypes.string,
    })),
    onChangeStation: PropTypes.func,
    onChange: PropTypes.func,
    onDeleteStation: PropTypes.func,
    onDuplicateStation: PropTypes.func,
    disabled: PropTypes.bool,
    actions: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string,
        onClick: PropTypes.func,
        color: PropTypes.string,
        iconName: PropTypes.string.isRequired,
        tooltip: PropTypes.string,
    })),
    exportButtonOnHeader: PropTypes.bool,
    stationsStats: PropTypes.objectOf(PropTypes.arrayOf(DtoMeasureStats)),
}

export default TabSelectThreshold